import { If } from 'cdui-js';
import { isErrorField } from '../errorKeyNormalize';
import { pState } from '../store';
import i18n from '../../../../../i18n';

export function shouldShowReEditHint(field?: string, errorField?: string) {
  const key = errorField ?? field;
  return isErrorField(key, pState.errorKeys);
}

export const FieldReEditHint = (props: { field?: string; errorField?: string; class?: string }) => (
  <If when={shouldShowReEditHint(props.field, props.errorField)}>
    <div class={`color-error font-s-XS margin-t-XXS ${props.class ?? ''}`.trim()}>{i18n.OpenProgress.Common.ReEditField}</div>
  </If>
);
